import { computed } from 'vue'
import type { ComputedRef } from 'vue'
import { useRoute } from 'vue-router'
import type { RouteLocationNormalizedLoaded } from 'vue-router'

import type { AffiliateScope } from '@/Network/Types/Requests/AntecipeAffiliateRequests'

import type { AffiliatePage } from './labels'
import { affiliatePortalPath } from './routes'

export function scopeFromRoute(
  route: Pick<RouteLocationNormalizedLoaded, 'meta' | 'params'>
): AffiliateScope {
  if (route.meta.affiliateImpersonation) {
    const id = Number(route.params.affiliateId)
    if (Number.isInteger(id) && id > 0) return { kind: 'admin', affiliateId: id }
  }
  return { kind: 'self' }
}

export function useAffiliateScope(): ComputedRef<AffiliateScope> {
  const route = useRoute()
  return computed(() => scopeFromRoute(route))
}

/** Links internos do portal preservam o escopo ("ver como" continua "ver como"). */
export function useAffiliatePortalNav() {
  const scope = useAffiliateScope()
  const portalPath = (page: AffiliatePage): string =>
    affiliatePortalPath(page, scope.value.kind === 'admin' ? scope.value.affiliateId : null)
  return { scope, portalPath }
}
